import * as React from "react";
import { graphql } from "react-apollo";
import * as moment from "moment";
import * as validator from "validator";
import { Link, withRouter } from "react-router-dom";
import { RouteComponentProps } from "react-router";
import { TiMail, TiLockClosedOutline } from "react-icons/ti";
import styled from "@emotion/styled";
import {
  Button,
  FormGroup,
  Label,
  Input,
  InputGroup,
  InputGroupAddon
} from "reactstrap";

// GraphQL
import Authenticate from "../../GraphQL/Mutations/Authenticate";

// Presentation/UI
import { LogoText } from "../../Components/Text";
import Loader from "../../Components/Loader";

// Theme
import { Colors } from "../../Themes";

// Utils
import { AUTH_USER_TOKEN } from "../../Utils/LocalStorage";

interface IState {
  email: string;
  password: string;
  loading: boolean;
  error: string | null;
}

type PropsType = RouteComponentProps<any> & {
  history: any;
  mutate: any;
};

const LoginContainer = styled.div`
  width: 100%;
  & input {
    background: transparent !important;
  }
  & .input-group {
    background: rgba(214, 219, 230, 0.36) !important;
    border-radius: 0.25rem;
  }
  & a {
    color: ${Colors.cmmsBlue};
    text-decoration: none;
  }
`;

class LoginForm extends React.Component<PropsType, IState> {
  state: IState = {
    email: "",
    password: "",
    loading: false,
    error: null
  };

  // Update input fields with each event change
  handleChange = (e: React.FormEvent<HTMLInputElement>) => {
    const { name, value }: { name: string; value: string } = e.currentTarget;
    if (name === "email") {
      this.setState({
        email: value
      });
    } else if (name === "password") {
      this.setState({
        password: value
      });
    }
  };

  // Validate fields before invoking auth mutation
  authenticateUser = (): boolean => {
    const { email, password } = this.state;
    const { mutate } = this.props;

    // Validate fields
    if (!email || !password) {
      this.setError("Fields cannot be empty.");
      return false;
    }

    // Validate email
    if (!validator.isEmail(email)) {
      this.setError("Please enter a valid email address.");
      return false;
    }

    this.setState({ loading: true });

    mutate({
      variables: {
        email,
        password
      }
    })
      .then((res: any) => {
        this.setState({ loading: false });
        window.localStorage.setItem(
          AUTH_USER_TOKEN,
          res.data.authenticateUser.token
        );
        // Redirect to dashboard page
        // history.push("/dashboard");
        window.location.replace("/dashboard");
      })
      .catch((err: any) => {
        console.log(err);
        this.setState({ loading: false });
        this.setError("Invalid credentials.");
        return false;
      });

    return true;
  };

  // Error
  setError = (error: string): void => {
    this.setState(
      {
        error
      },
      () => {
        setTimeout(() => {
          this.setState({ error: null });
        }, 3000);
      }
    );
  };

  render() {
    const { email, password, loading } = this.state;

    return (
      <LoginContainer>
        <Link to="/">
          <LogoText>maintain.</LogoText>
        </Link>
        <br />
        <FormGroup>
          <Label for="userEmail">Email Address</Label>
          <InputGroup>
            <InputGroupAddon addonType="prepend">
              <TiMail size="1.5em" />
            </InputGroupAddon>
            <Input
              type="email"
              name="email"
              value={email}
              id="userEmail"
              placeholder=""
              onChange={this.handleChange}
            />
          </InputGroup>
        </FormGroup>
        <FormGroup>
          <Label for="userPassword">Password</Label>
          <InputGroup>
            <InputGroupAddon addonType="prepend">
              <TiLockClosedOutline size="1.5em" />
            </InputGroupAddon>
            <Input
              type="password"
              name="password"
              value={password}
              id="userPassword"
              placeholder=""
              onChange={this.handleChange}
            />
          </InputGroup>
        </FormGroup>

        <FormGroup>Forgot password?</FormGroup>
        <br />
        <Button onClick={() => this.authenticateUser()}>
          {!loading ? <span>Sign In</span> : <Loader />}
        </Button>
        <br />
        <br />
        {this.state.error && (
          <p style={{ textAlign: "center", color: Colors.error }}>
            {this.state.error}
          </p>
        )}
        <br />
        <FormGroup className="center-align">
          Don't have an account? <Link to="/sign-up">Sign Up</Link>
        </FormGroup>
        <FormGroup className="center-align">
          <span
            style={{
              fontSize: "12px",
              color: Colors.semiBlack,
              marginTop: 30
            }}
          >
            Copyright &copy; {moment().format("YYYY")}
          </span>
        </FormGroup>
      </LoginContainer>
    );
  }
}

export default graphql(Authenticate)(withRouter(LoginForm));



// WEBPACK FOOTER //
// ./src/Containers/Login/LoginForm.tsx